export default {"src":"/_next/static/media/bg-shape-red.13c297dc.svg","height":189,"width":1376,"blurWidth":0,"blurHeight":0};